import { Button, ButtonGroup, Card, FormGroup, MenuDivider } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { IFieldProps } from "decorator-form";
import React from "react";
import { v4 as generateUuid } from "uuid";
import TokenSession from "core/util/session/TokenSession";
import { EditableTextWidget } from "common/form/widgets/EditableTextWidget";
import TextWidget from "common/form/widgets/TextWidget";
import { arrayMove } from "core/util/ArrayUtils";

export interface IQuickLink {
	id: string;
	title: string;
	body: string;
	iconUrl: string;
	link: string;
}

export class QuickLinksField extends React.PureComponent<IFieldProps<IQuickLink[]>> {

	public render() {
		const { formData } = this.props;

		const items = formData || [];

		return (
			<div>
				{
					items.map((item, i) => (
						<div key={item.id} style={{ margin: "15px 0px", minWidth: "400px" }}>
							<Card>
								<React.Fragment>
								<div style={{ marginBottom: "15px" }}>
									<h3>
										<EditableTextWidget
											autofocus={false}
											disabled={false}
											label="Add title..."
											onChange={(v) => this.onChangeItem(items, i, 'title', v)}
											options={undefined}
											readonly={false}
											value={item.title}
										/>
									</h3>
								</div>
								<div style={{ marginBottom: "15px" }}>
									<EditableTextWidget
										autofocus={false}
										disabled={false}
										label="Add description (optional)"
										multiline={true}
										onChange={(v) => this.onChangeItem(items, i, 'body', v)}
										options={undefined}
										readonly={false}
										value={item.body}
									/>
								</div>
								</React.Fragment>
								<div style={{ marginBottom: "15px" }}>
									<TextWidget
										autofocus={false}
										disabled={false}
										options={undefined}
										placeholder="Add Icon URL"
										fill={true}
										readonly={false}
										onChange={(v) => this.onChangeItem(items, i, 'iconUrl', v)}
										value={item.iconUrl}
									/>
								</div>
								<div style={{ marginBottom: "15px" }}>
									<TextWidget
										autofocus={false}
										disabled={false}
										options={undefined}
										placeholder="Add Link URL"
										fill={true}
										readonly={false}
										onChange={(v) => this.onChangeItem(items, i, 'link', v)}
										value={item.link}
									/>
								</div>
								<ButtonGroup>
									<Button icon={IconNames.REMOVE} onClick={() => this.onRemoveItem(items, i)} />
									{
										i > 0 && (
											<Button icon={IconNames.ARROW_UP} onClick={() => this.onSort(items, i, i - 1)} />
										)
									}
									{
										i < (items.length - 1) && (
											<Button icon={IconNames.ARROW_DOWN} onClick={() => this.onSort(items, i, i + 1)} />
										)
									}
								</ButtonGroup>
							</Card>
						</div>
					))
				}
				
				<FormGroup>
					<Button text="Add Another" icon={IconNames.ADD} onClick={() => this.onAddItem(items)} />
				</FormGroup>
			</div>
		);
	}

	private onChangeItem = (prevData: IQuickLink[], index: number, field: string, value: any) => {
		const nextData = prevData.map((item, i) => index === i ? ({ ...item, [field]: value}) : item);
		this.props.onChange(nextData);
	}

	private onRemoveItem = (prevData: IQuickLink[], index: number) => {
		this.props.onChange(prevData.filter((_, i) => index !== i));
	}

	private onAddItem = (prevData: IQuickLink[]) => {
		const nextData = [...prevData || [], this.getEmpty()];
		this.props.onChange(nextData);
	}

	private onSort = (prevData: IQuickLink[], oldIndex: number, newIndex: number) => {
		const nextData = arrayMove([...prevData], oldIndex, newIndex);
		this.props.onChange(nextData);
	}

	private getEmpty = (): IQuickLink => {
		return { id: generateUuid(), title: undefined, body: undefined, iconUrl: undefined, link: undefined };
	}

}



// WEBPACK FOOTER //
// ./src/panels/quickLinks/form/QuickLinksField.tsx